import { React, useEffect } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ThemePicker from "./ThemePicker.jsx";
import MultiColorPicker from "./MultiColorPicker.jsx";
import IconSelector from "./IconSelector";
import axios from "axios";
import config from "../../config";

export default function ThemeIcon({
  formData,
  handleChange,
  saving,
  isFieldVisible = () => true,
}) {
  const { t } = useTranslation();
  const organizationId = JSON.parse(localStorage.getItem("userState"))?.user?.organizationId;
  console.log("organizationId", organizationId);

  useEffect(() => {
    const fetchOrganizationIcons = async () => {
      try {
        const response = await axios.get(
          `${config.baseURL}/icon/organizations/${organizationId}/icons`,
          { withCredentials: true }
        );

        const icons = response.data.icons;
        console.log("Fetched organization icons:", icons);
      } catch (error) {
        console.error("Error fetching organization icons:", error);
      }
    };

    if (organizationId) {
      fetchOrganizationIcons();
    }
  }, [organizationId]);

  // Helper function to handle icon changes - updates local state
  const handleIconChange = (fieldName, iconPath) => {
    console.log(`Icon selection changed for ${fieldName}: ${iconPath}`);
    
    handleChange({
      target: {
        name: fieldName,
        value: iconPath,
      },
    });
  };

  return (
    <Box className="settings-container">
      {/* Dark Mode */}
      {/* <Box className="setting-row">
        <Typography className="form-label">{t("Dark Mode")}</Typography>
        <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.theme === "Dark"}
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: "theme",
                      value: e.target.checked ? "Dark" : "Light",
                    },
                  })
                }
                disabled={saving}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#20A8E0",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#20A8E0",
                  },
                }}
              />
            }
            label={formData.theme === "Dark" ? t("Enabled") : t("Disabled")}
            sx={{
              margin: 0,
              "& .MuiFormControlLabel-label": {
                fontSize: "14px",
                color: formData.theme === "Dark" ? "#414958" : "#757575",
              },
            }}
          />
        </Box>
      </Box> */}

      {/* Theme Picker */}
      {/* <Box className="setting-row">
        <Typography className="form-label">{t("Theme")}</Typography>
        <Box sx={{ flex: 1 }}>
          <ThemePicker
            value={formData.theme}
            onChange={handleChange}
            disabled={saving}
          />
        </Box>
      </Box> */}

      {/* Vehicle Colors */}
      {/* <Box className="setting-row">
        <Typography className="form-label">
          {t("Vehicle Color - Idle")}
        </Typography>
        <Box sx={{ flex: 1 }}>
          <MultiColorPicker
            value={formData.vehicleColorIdle}
            onChange={(e) =>
              handleChange({
                target: { name: "vehicleColorIdle", value: e.target.value },
              })
            }
            disabled={saving}
          />
        </Box>
      </Box> */}

      {/* <Box className="setting-row">
        <Typography className="form-label">
          {t("Vehicle Color - Going to Destination")}
        </Typography>
        <Box sx={{ flex: 1 }}>
          <MultiColorPicker
            value={formData.vehicleColorGoingToDestination}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "vehicleColorGoingToDestination",
                  value: e.target.value,
                },
              })
            }
            disabled={saving}
          />
        </Box>
      </Box> */}

      {/* <Box className="setting-row">
        <Typography className="form-label">
          {t("Vehicle Color - Going to Origin")}
        </Typography>
        <Box sx={{ flex: 1 }}>
          <MultiColorPicker
            value={formData.vehicleColorGoingToOrigin}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "vehicleColorGoingToOrigin",
                  value: e.target.value,
                },
              })
            }
            disabled={saving}
          />
        </Box>
      </Box> */}

      {isFieldVisible("vehicleIcons") && (
      <>
      {/* Vehicle Icon */}
      <Box className="setting-row">
        <Typography className="form-label">{t("Vehicle Icon")}</Typography>
        <Box sx={{ flex: 1 }}>
          <IconSelector
            iconType="vehicleIcon"
            label={t("Vehicle Icon")}
            value={formData.vehicleIcons || ""}
            onChange={(e) => handleIconChange("vehicleIcons", e.target.value)}
            disabled={saving}
            organizationId={organizationId}
          />
        </Box>
      </Box>

      {/* Stop Origin Icon */}
      <Box className="setting-row">
        <Typography className="form-label">{t("Stop Origin Icon")}</Typography>
        <Box sx={{ flex: 1 }}>
          <IconSelector
            iconType="stopOriginIcon"
            label={t("Stop Origin Icon")}
            value={formData.stopOriginIcons || ""}
            onChange={(e) => handleIconChange("stopOriginIcons", e.target.value)}
            disabled={saving}
            organizationId={organizationId}
          />
        </Box>
      </Box>

      {/* Stop Destination Icon - THIS IS THE KEY FIX */}
      <Box className="setting-row">
        <Typography className="form-label">
          {t("Stop Destination Icon")}
        </Typography>
        <Box sx={{ flex: 1 }}>
          <IconSelector
            iconType="stopDestinationIcon"
            label={t("Stop Destination Icon")}
            value={formData.stopDestinationIcons || ""}
            onChange={(e) => handleIconChange("stopDestinationIcons", e.target.value)}
            disabled={saving}
            organizationId={organizationId}
          />
        </Box>
      </Box>

      {/* Intermediate Stop Icon */}
      <Box className="setting-row">
        <Typography className="form-label">
          {t("Intermediate Stop Icon")}
        </Typography>
        <Box sx={{ flex: 1 }}>
          <IconSelector
            iconType="intermediateStopIcon"
            label={t("Intermediate Stop Icon")}
            value={formData.intermediateStopsIcons || ""}
            onChange={(e) => handleIconChange("intermediateStopsIcons", e.target.value)}
            disabled={saving}
            organizationId={organizationId}
          />
        </Box>
      </Box>
      </>
      )}

      {/* Charging Point Icon */}
      {/* <Box className="setting-row">
        <Typography className="form-label">
          {t("Charging Point Icon")}
        </Typography>
        <Box sx={{ flex: 1 }}>
          <IconSelector
            iconType="chargingPointIcon"
            label={t("Charging Point Icon")}
            value={formData.chargingPointIcons || ""}
            onChange={(e) => handleIconChange("chargingPointIcons", e.target.value)}
            disabled={saving}
            organizationId={organizationId}
          />
        </Box>
      </Box> */}

      {/* Railway Station Icon */}
      {/* <Box className="setting-row">
        <Typography className="form-label">
          {t("Railway Station Icon")}
        </Typography>
        <Box sx={{ flex: 1 }}>
          <IconSelector
            iconType="railwayStationIcon"
            label={t("Railway Station Icon")}
            value={formData.railwayStationIcons || ""}
            onChange={(e) => handleIconChange("railwayStationIcons", e.target.value)}
            disabled={saving}
            organizationId={organizationId}
          />
        </Box>
      </Box> */}
    </Box>
  );
}